<template>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                    v-bind="attrs"
                    icon
                    @touchstart="openBrushSizeMenu"
                    @click="openBrushSizeMenu">
                <v-icon>mdi-palette</v-icon>
            </v-btn>
            <v-menu
                    v-model="brushSizeMenu"
                    :close-on-content-click="false"
                    offset-y
                    v-bind="attrs"
                    absolute
                    v-on="on">
                <v-card class="px-2 py-1">
                    <span class="caption">Brush Colour</span>
                    <v-color-picker
                            v-model="localBrush.color"
                            hide-canvas
                            hide-inputs
                            hide-controls
                            hide-mode-switch
                            show-swatches
                            :swatches="swatches" />
                    <span class="caption">Brush Size</span><br>
                    <div class="text-center">
                        <v-btn
                                :disabled="!decrementBrushSizeAvailable"
                                icon
                                @click="decrementBrushSize()">
                            <v-icon>mdi-minus</v-icon>
                        </v-btn>
                        <span class="caption"><b>{{ currentBrushSizeKey }}</b></span>
                        <v-btn
                                :disabled="!incrementBrushSizeAvailable"
                                icon
                                @click="incrementBrushSize()">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </div>
                </v-card>
            </v-menu>
        </template>
        <span>Open brush settings</span>
    </v-tooltip>
</template>

<script>
    export default {
        name: "DrawingBrushMenu",
        model: {
            prop: 'brush',
            event: 'update'
        },
        props: {
            brush: {type: Object, default: () => {
                return {
                    color: '#000',
                    size: 1,
                }
            }},
        },
        data() {
            return {
                localBrush: {
                    color: this.brush.color,
                    size: this.brush.size,
                },
                brushSizeMenu: false,
                currentBrushSizeKey: 1,
                brushSizes: new Map([
                    [1, 2],
                    [2, 4],
                    [3, 10],
                    [4, 18],
                    [5, 32]
                ]),
                swatches: [
                    ['#000000',
                     '#F44336',],
                    ['#FF9800',
                     '#9C27B0',],
                    ['#2196F3',
                     '#4CAF50',],
                    ['#FFEB3B',
                     '#DEDEDE'],
                ]
            }
        },
        computed: {
            incrementBrushSizeAvailable() {
                return this.localBrush.size < this.brushSizes.get(Math.max(...this.brushSizes.keys()))
            },
            decrementBrushSizeAvailable() {
                return this.localBrush.size > this.brushSizes.get(Math.min(...this.brushSizes.keys()))
            },
        },
        watch: {
            localBrush: {
                handler() {
                    this.$emit('update', this.localBrush)
                },
                deep: true,
            }
        },
        methods: {
            openBrushSizeMenu() {
                setTimeout(() => {
                    this.brushSizeMenu = true
                }, 1);
            },
            incrementBrushSize() {
                this.localBrush.size = this.brushSizes.get(++this.currentBrushSizeKey)
            },
            decrementBrushSize() {
                this.localBrush.size = this.brushSizes.get(--this.currentBrushSizeKey)
            },
        }
    }
</script>
<style>
.v-color-picker {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: none !important;
}
.v-color-picker__controls {
  display: none !important;
}
.v-color-picker__color {
  width: 25px !important;
  height: 25px !important;
  max-height: 25px !important;
}
.v-color-picker__color > div {
  border: thin solid rgba(0,0,0,.12) !important;
}

.v-color-picker__color path {
  filter: invert(1);
}
.v-color-picker__swatch {
  margin-bottom: 0px !important;
}
</style>